module.exports = __webpack_public_path__ + "static/img/crane.a5481bfa.png";